module.exports = __webpack_public_path__ + "static/media/intro-screen-colored.80e379db.svg";